<template>
  <DialogComponent
    :closeClick="false"
    :dialog-title="title"
    :dialogVisible.sync="visible"
    center
    width="45vw"
    @dialogClose="closeDialog"
  >
    <div slot="content" style="padding: 10px 30px 20px 30px">
      <div style="height: 30vh; margin: auto">
        <el-col
          :lg="24"
          :md="24"
          :sm="24"
          :xl="24"
          :xs="24"
          style="margin-top: 20px"
        >
          <el-col
            :lg="7"
            :md="7"
            :sm="7"
            :xl="7"
            :xs="7"
            style="line-height: 28px; text-align: right; margin-right: 10px"
          >
            {{ spaceLabel }}：
          </el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
            <span
              class="text-blue"
              style="font-size: inherit; height: 28px; line-height: 28px"
              >{{ spaceValue }}</span
            >
          </el-col>
        </el-col>
        <el-col
          :lg="24"
          :md="24"
          :sm="24"
          :xl="24"
          :xs="24"
          style="margin-top: 20px"
        >
          <el-col
            :lg="7"
            :md="7"
            :sm="7"
            :xl="7"
            :xs="7"
            style="line-height: 28px; text-align: right; margin-right: 10px"
          >
            SVG名称：
          </el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
            <el-input
              class="inline-input"
              placeholder="请输入SVG名称"
              size="mini"
              style="width: 80%"
              v-model="formData.name"
            ></el-input>
          </el-col>
        </el-col>
        <el-col
          :lg="24"
          :md="24"
          :sm="24"
          :xl="24"
          :xs="24"
          style="margin-top: 20px"
        >
          <el-col
            :lg="7"
            :md="7"
            :sm="7"
            :xl="7"
            :xs="7"
            style="line-height: 28px; text-align: right; margin-right: 10px"
          >
            图片：
          </el-col>
          <el-col
            :lg="15"
            :md="15"
            :sm="15"
            :xl="15"
            :xs="15"
            v-if="formData.url"
          >
            <div class="upload-div">
              <img :src="$ftpUrl + formData.url" class="upload-img" />
              <div class="delete-icon">
                <span @touchstart="imageRemove"  @click="imageRemove">
                  <i class="el-icon-delete"></i>
                </span>
              </div>
            </div>
          </el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15" v-else>
            <div class="upload-wrapper">
              <el-upload
                :action="uploadUrl"
                :auto-upload="true"
                :headers="token"
                :before-upload="beforeUpload"
                :accept="'image/*'"
                :on-error="imageChangeError"
                :on-success="imageChangeSuccess"
                :show-file-list="false"
                class="upload-demo"
                drag
                v-loading="loading"
                element-loading-text="上传中..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
              >
                <i
                  class="el-icon-plus"
                  style="line-height: 80px; height: 80px; width: 80px"
                ></i>
              </el-upload>
            </div>
          </el-col>
        </el-col>
        <el-col
          :span="24"
          class="hidden-sm-and-up"
          style="height: 8px"
        ></el-col>
        <el-col
          :span="24"
          class="hidden-md-and-down"
          style="height: 13px"
        ></el-col>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      style="text-align: center; margin-bottom: 15px"
    >
      <el-button @touchstart="closeDialog"  @click="closeDialog" size="mini">关 闭</el-button>
      <el-button @touchstart="preservation" @click="preservation" type="primary" size="mini"
        >保 存</el-button
      >
    </div>
  </DialogComponent>
</template>

<script>
import DialogComponent from "@/components/DialogComponent";
import { serviceUrl } from "@/utils/request";
import { imgUploadAstrict } from "@/constant/img-upload-astrict";
import { saveSvg } from "@/network/device-topology"
import lodash from "lodash";

export default {
  name: "upload",
  props: ["title", "dialogVisible", "spaceForm", "spaceLabel", "spaceValue"],
  components: {
    DialogComponent,
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
    },
    spaceForm: {
      handler() {
        this.initPosition();
      },
      deep: true,
    },
  },
  data() {
    return {
      visible: false,
      uploadUrl:
        window.g.gatewayUrl.slice(0, -1) +
        serviceUrl.deviceService +
        "/api/upload",
      token: {},
      formData: {},
      loading: false,
    };
  },
  mounted() {
    this.token = { Authorization: "Bearer" + this.$cookies.get("token") };
  },
  methods: {
    imageRemove() {
      this.formData.url = "";
      // 重新渲染
      this.$forceUpdate();
    },
    initPosition() {
      this.formData = lodash.cloneDeep(this.spaceForm);
    },
    closeDialog(tag= false) {
      this.$emit("closeUploadDialog", tag);
    }, // 文件类型校验
    beforeUpload(file) {
      this.loading = true;
      return imgUploadAstrict(file, this);
    },
    imageChangeError() {
      this.loading = false;
      this.$message.error("文件上传失败!");
    },
    imageChangeSuccess(file) {
      this.loading = false;
      this.formData.url = file.data.domain + file.data.url;
      // 重新渲染
      this.$forceUpdate();
    },
    preservation() {
      if (!this.formData.name){
       return this.$message.error("请输入SVG名称!");
      }
      if (!this.formData.url) {
        return this.$message.error("请上传图片!");
      }
      console.log(this.formData, "this.formData")
      saveSvg({
        spaceId: this.formData.spaceId,
        id: this.formData.id,
        name: this.formData.name,
        url: this.formData.url,
      }).then(res => {
        if (res.code === 0) {
          this.$message.success("保存成功!");
          this.closeDialog(true);
        } else {
          this.$message.error(res.message);
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.delete-icon {
  line-height: 80px;
  height: 80px;
  width: 80px;
  position: absolute;
  text-align: center;
  display: none;
}

.upload-img {
  position: absolute;
  width: 80px;
  height: 80px;
}

.upload-div {
  margin-bottom: 145px;
}

.upload-img:hover + .delete-icon {
  display: block;
}

.delete-icon:hover {
  display: block;
}

.upload-wrapper {
  margin-bottom: 60px;
  
  ::v-deep .el-upload {
    display: block;
    width: 80px;
    height: 80px;
  }

  ::v-deep .el-upload-dragger {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }

  ::v-deep .el-loading-mask {
    border-radius: 6px;
  }

  ::v-deep .el-loading-spinner {
    margin-top: -25px;
    
    .el-icon-loading {
      font-size: 24px;
      color: #fff;
    }
    
    .el-loading-text {
      color: #fff;
      font-size: 12px;
      margin-top: 5px;
    }
  }
}
</style>
